import { TEACHING_SURFACE } from "../constants/teaching";

/**
 * Teaching-surface slide metadata contract (UPPERCASE, absent = SLIDE).
 * Spec: docs/superpowers/specs/2026-07-20-teaching-surface-bite-type-design.md
 */
export const isNotepadSurface = (
  metadata?: { teaching_surface?: string | null } | null,
): boolean => metadata?.teaching_surface === TEACHING_SURFACE.NOTEPAD;
